import { createSelector } from 'react-sweet-state';

import type { FieldValues } from '../../../../common/types/form/form-fields/field-values';
import { asFilesValue } from '../../../../common/types/form/form-fields/field-values/utils';
import { currentValuesSelector } from '../current-values';

/*
 * Selector to get the total number of attachments on the form, across all fields.
 */
export const totalFormAttachmentsSelector: import('react-sweet-state').OutputSelector<
	import('../../types').FormRendererState,
	void,
	number
> = createSelector(currentValuesSelector, (currentValues: FieldValues) =>
	Object.values(currentValues)
		.map(asFilesValue)
		.reduce(
			(totalFiles, currentFilesValue) => totalFiles + (currentFilesValue?.files.length ?? 0),
			0,
		),
);
